import { IQueueItem } from '@bg-shared/business/TooltipQueue/interfaces/IQueueItem';
import { TooltipName } from '@bg-shared/business/TooltipQueue/enums/TooltipName';

export const tooltipQueueSelectors = {
    getHead: (state: IQueueItem[]) => state[0],
    getTooltip: (name: TooltipName) => (state: IQueueItem[]) => {
        const head = tooltipQueueSelectors.getHead(state);
        const isHead = head?.name === name;

        return {
            show: isHead,
            duration: isHead ? head.duration ?? null : null,
        };
    },
};
